import { Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const ContractorOnly = ({ component: Component, ...props }) => {
  const { isContractor } = useAuth();

  if (!isContractor) return <Navigate to="/app/crm" replace />;

  return <Component {...props} />;
};

export default ContractorOnly;

